export enum EmptyAvatarVariantEnum {
	Orange = 1,
	Blue= 2,
	Yellow = 3
}
